import { useState } from "react";
import ChangePasswordModal from "../UI elements/ChangePasswordModal";
import X_Circle from "../../../../../Assets/Icons/x-circle.svg";
import { TextField, Button, InputAdornment, IconButton } from "@mui/material";
import DatePicker from "../UI elements/Datepicker";
import Calendar from "../../../../../Assets/Icons/calendar.svg";
import { Link } from "react-router-dom";
import DeleteAccountModal from "../UI elements/DeleteAccountModal";
import axiosInstance from "../../../../../axiosInstance";

const MobileView = (props) => {
  const [ChangesMade, setChangesMade] = useState(false);
  const [Name, setName] = useState(props.ProfileInfo.user.fullName);
  const [Email, setEmail] = useState(props.ProfileInfo.user.email);
  const [BirthDate, setBirthDate] = useState(props.ProfileInfo.user.birthDate);
  const [OverlayIsOpen, setOverlayIsOpen] = useState(false);
  const [Error, setError] = useState(""); // State to hold the error message
  const [PasswordModalIsOpen, setPasswordModalIsOpen] = useState(false);
  const [DeleteAccountIsOpne, setDeleteAccountIsOpen] = useState(false);

  const toggleDeleteAccount = (Bool) => {
    setOverlayIsOpen(Bool);
    setDeleteAccountIsOpen(Bool);
  };
  const toggleChangePassword = (Bool) => {
    setOverlayIsOpen(Bool);
    setPasswordModalIsOpen(Bool);
  };

  const requestDeleteAccount = () => {
    let Req = {
      method: "DELETE",
      baseURL: window.localStorage.getItem("BaseURL") + "/api/account",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axiosInstance(Req)
      .then((Res) => {
        window.localStorage.clear();
        window.sessionStorage.clear();
        window.location.assign("/");
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const handleNameChange = (e) => {
    let Value = e.target.value;

    setChangesMade(true);
    setName(Value);

    if (!Value.trim()) {
      setError("Name is mandatory"); // Set error message if the field is empty
      setChangesMade(false); // to keep save button disabled
    } else {
      setError(""); // Clear error message if the field is not empty
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setChangesMade(true);
  };
  const saveBirthDate = (NewDate) => {
    setBirthDate(NewDate);
    setChangesMade(true);
  };

  const clearName = () => {
    setError("Name is mandatory"); // Set error message if the field is empty
    setChangesMade(false); // to keep save button disabled
    setName("");
    setChangesMade(true);
  };

  const saveData = () => {
    let Req = {
      method: "POST",
      baseURL: window.localStorage.getItem("BaseURL") + "/api/account",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        login: Email,
        email: Email,
        fullName: Name,
        birthDate: BirthDate,
      },
    };
    axiosInstance(Req)
      .then((Res) => {
        console.log(Res);
        setChangesMade(false);
        props.UpdateProfileInfo();
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  return (
    <>
      <div className="profile-wrapper">
        {OverlayIsOpen ? (
          <div
            className="overlay"
            onClick={() => {
              setOverlayIsOpen(false);
              setDeleteAccountIsOpen(false);
              setPasswordModalIsOpen(false);
            }}
          ></div>
        ) : null}
        {PasswordModalIsOpen ? (
          <ChangePasswordModal Close={() => toggleChangePassword(false)} />
        ) : null}
        {DeleteAccountIsOpne ? (
          <DeleteAccountModal
            Close={() => toggleDeleteAccount(false)}
            RequestDeleteAccount={() => requestDeleteAccount()}
          />
        ) : null}
        <div className="form-wrapper">
          <main className="form-content">
            <TextField
              autoComplete="off" // Disable autofill
              fullWidth
              id="name"
              name="name"
              label={"Name"}
              placeholder={""}
              variant="outlined"
              value={Name}
              onChange={handleNameChange}
              required // Make the field mandatory
              error={Boolean(Error)} // Show error state based on whether there is an error message
              helperText={Error} // Display error message below the field
              margin="normal"
              sx={{
                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "transparent",
                  },
                backgroundColor: props.isMobileOrTablet
                  ? "#F3EEE6"
                  : "transparent",
                borderRadius: props.isMobileOrTablet ? "4px 4px 0 0" : "4px",
                borderBottom: Error ? "3px solid #b3261e" : "3px solid #FB4764",
                width: "95%",
                ...(props.isMobileOrTablet && {
                  "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                }),
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {Name && ( // Render clear button only if username has value
                      <IconButton
                        aria-label="clear username"
                        onClick={clearName}
                        edge="end"
                        style={{ color: "#FB4764" }}
                      >
                        <img alt="x" src={X_Circle} />
                      </IconButton>
                    )}
                  </InputAdornment>
                ),
              }}
            />
            <div className="datepicker-wrapper">
              <DatePicker
                Label={"Birth date"}
                isMobileOrTablet
                DefaultValue={
                  props.ProfileInfo.birthDate
                    ? props.ProfileInfo.birthDate
                    : new Date()
                }
                SaveNewDate={(Birthdate) => saveBirthDate(Birthdate)}
              />
              <img className="datepicker-trigger" alt="" src={Calendar} />
            </div>
            <TextField
              autoComplete="off" // Disable autofill
              fullWidth
              id="email"
              disabled
              name="weddingly-username"
              label={"Email"}
              variant="outlined"
              placeholder={""}
              value={Email}
              onChange={handleEmailChange}
              margin="normal"
              sx={{
                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: props.isMobileOrTablet
                      ? "transparent"
                      : "#79747E", // Change border color when focused
                  },
                backgroundColor: props.isMobileOrTablet
                  ? "#F3EEE6"
                  : "transparent",
                borderRadius: props.isMobileOrTablet ? "4px 4px 0 0" : "4px",

                width: "95%",
                ...(props.isMobileOrTablet && {
                  "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                }),
              }}
            />
            <Button
              type="submit"
              variant="contained"
              disabled={ChangesMade ? false : true}
              onClick={() => saveData()}
              sx={{
                backgroundColor: "#F8FAE5",
                "&:hover": {
                  backgroundColor: "#F8FAE5",
                },
                height: props.isMobileOrTablet ? "36px" : "56px",
                fontSize: "14px",
                display: "flex",
                width: "95%",
                color: props.isMobileOrTablet ? "#292D32" : "#ffff",
                boxShadow: props.isMobileOrTablet ? "none" : "",
                marginTop: props.isMobileOrTablet ? "16px" : "",
                gridGap: "8px",
                textTransform: "none", // Prevent text from being all caps,
              }}
            >
              Save
            </Button>
            <Link to="/Home">
              <Button
                type="submit"
                variant="contained"
                sx={{
                  backgroundColor: "#F8FAE5",
                  "&:hover": {
                    backgroundColor: "#F8FAE5",
                  },
                  height: props.isMobileOrTablet ? "36px" : "56px",
                  fontSize: "14px",
                  display: "flex",
                  width: "100%",
                  color: props.isMobileOrTablet ? "#292D32" : "#ffff",
                  boxShadow: props.isMobileOrTablet ? "none" : "",
                  marginTop: props.isMobileOrTablet ? "16px" : "",
                  gridGap: "8px",
                  textTransform: "none", // Prevent text from being all caps,
                }}
              >
                Cancel
              </Button>
            </Link>
            <p className="action-text">
              To change your password{" "}
              <p className="trigger" onClick={() => toggleChangePassword(true)}>
                Click here
              </p>
            </p>
            <p className="action-text">
              To delete your account{" "}
              <p className="trigger" onClick={() => toggleDeleteAccount(true)}>
                Click here
              </p>
            </p>
          </main>
        </div>
      </div>
    </>
  );
};

export default MobileView;
